export default {
	listing: {
		// What page we are on
		page: 1
	},

	// Helpers to keep track of selected case, offer, proposal
	caseId: null,
	offerId: null,
	proposalId: null,

	// All data related to case except proposals and offers
	case: {},

	// All data related to proposals and offers
	proposals: [],

	// attached PubSub listeners
	subscribers: {},

	// God's mode for seeing meta data of fields in the form
	isGodMode: false
}
